import cn from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import * as styles from './Columns.module.scss';

const Columns = ({ Item, items, rowGap, columnCount, columnGap }) => (
  <ul className={cn(
    styles.root, styles[`column${columnCount}`],
    styles[`rowGap${rowGap}`],
    styles[`columnGap${columnGap}`]
  )}>
    {items.map((props, i) => (
      <li key={i}>
        <Item {...props} i={i} />
      </li>
    ))}
  </ul>
);

Columns.propTypes = {
  Item: PropTypes.func.isRequired,
  items: PropTypes.array.isRequired,
  rowGap: PropTypes.oneOf(['S', 'M']),
  columnGap: PropTypes.oneOf(['M', 'L']),
  columnCount: PropTypes.number,
};
Columns.defaultProps = {
  rowGap: 'M',
  columnGap: 'M',
  columnCount: 3,
};

export default Columns;
